import React from 'react'
import { default as LinkComponent, LinkProps } from 'next/link'

import './Link.scss'
import classy from 'shared/utils/classy'
import { DSColors } from 'shared/timber/common/types'

type HrefLinkType = Pick<LinkProps, 'href'>

interface Props extends HrefLinkType {
  target?: string
  children: React.ReactNode
  'data-testid'?: string
  color?: Extract<DSColors, 'secondary-1'>
  underlineHover?: boolean
  bold?: boolean
  prefetch?: boolean
}

const Link = ({
  'data-testid': dataTestId,
  children,
  href,
  target,
  color,
  bold = false,
  underlineHover = false,
  prefetch = false,
}: Props) => {
  return (
    <LinkComponent
      href={href}
      target={target}
      className={classy(
        'Link',
        color === 'secondary-1' && 'Link--secondary-1',
        underlineHover && 'Link--underline-hover',
        bold && 'Link--bold',
      )}
      data-testid={dataTestId || 'link'}
      prefetch={prefetch}
    >
      {children}
    </LinkComponent>
  )
}
export default Link
